import type {Offer} from '@/redux/v1/offers/list/models';

export const FETCH_OFFER_ALTERNATIVE_FLIGHTS =
  'redux/v1/offerAlternativeFlights/fetchOfferAlternativeFlights';

export type Query = {
  offerId: string;
};

export type AlternativeFlightOffer = Offer;

export type Status = 'idle' | 'loading' | 'successful' | 'failed';
export type Data = Array<AlternativeFlightOffer>;

type StatusState = Record<string, Status>;
type ByQueryState = Record<string, Data>;
type ByOfferIdState = Record<string, AlternativeFlightOffer>;
type ErrorsState = Record<string, null | Error>;

export type OfferAlternativeFlightsState = {
  status: StatusState;
  byQuery: ByQueryState;
  byOfferId: ByOfferIdState;
  errors: ErrorsState;
};
